<div class="card">
  <h3 class="card__title">
    Counter
    <span class="card__badge card__badge--default">Default CD</span>
  </h3>
  <p class="card__desc">
    Uses <code>ChangeDetectionStrategy.Default</code>. Angular checks this component on every tick,
    making all sibling OnPush components appear as unnecessary renders (red).
  </p>
  <div class="counter">
    <button class="btn" (click)="decrement()" aria-label="Decrement">−</button>
    <span class="counter__value" aria-live="polite" aria-label="Count: {{ count() }}">
      {{ count() }}
    </span>
    <button class="btn" (click)="increment()" aria-label="Increment">+</button>
  </div>
  <div class="card__actions">
    <button class="btn btn--secondary" (click)="toggleAuto()">
      {{ autoRunning() ? 'Stop Auto' : 'Start Auto' }}
    </button>
    <span class="card__hint">Auto: every {{ intervalMs }}ms</span>
  </div>
</div>
